import React from 'react';

interface SliderRailProps {
  getRailProps: () => any;
}

export const SliderRail: React.FC<SliderRailProps> = ({ getRailProps }) => (
  <>
    <div className="range-slider__rail__outer" {...getRailProps()} />
    <div className="range-slider__rail__inner" />
  </>
);
